import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditSmartFilterModalOpenedFrom } from '../models/automation/enum/add-edit-smart-filter-modal-opened-from';
import { HydratedSmartFilter } from '../models/automation/hydrated-smart-filter';
import { AddEditSmartFilterModalComponent } from '../views/smart-filters/modal/add-edit-smart-filter-modal/add-edit-smart-filter-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';

export class ModalEditSmartFilter {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    openedFrom: AddEditSmartFilterModalOpenedFrom,
    smartFilter: HydratedSmartFilter,
    onClose?: (req: HydratedSmartFilter) => void
  ): void {
    ngZone.run(() => {
      const modalRef = ngbModal.open(
        AddEditSmartFilterModalComponent,
        ModalUtils.addEditSmartFiltersModalOptions(injector)
      );
      const compInstance = modalRef.componentInstance as AddEditSmartFilterModalComponent;
      compInstance.viewModel.connectToIsEditing(true);
      compInstance.viewModel.connectToOpenedFrom(openedFrom);
      const smartFilterCopy = window.injector.Deserialize.instanceOf(HydratedSmartFilter, smartFilter);
      compInstance.viewModel.connectToExistingSmartFilter(smartFilterCopy);
      modalRef.result
        .then(editedFilter => {
          if (!editedFilter && exists(onClose)) {
            onClose(editedFilter);
          }
        })
        .catch(() => {});
    });
  }
}
